module.exports = __webpack_public_path__ + "static/media/8.629bb893.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/img/instagram/8.jpg
// module id = 558
// module chunks = 0